import { PMOrderType } from 'src/app/models/domain';

export abstract class PMOrderConstants {
  public static primaryOrderTypes: ReadonlyArray<PMOrderType> = [
    PMOrderType.ZML1,
    PMOrderType.ZML2,
    PMOrderType.ZML7,
  ];
}
